import { useCallback } from 'react';
import { OrthodonticsPhasesKeys } from '../../../orthodontics/components/layout';
import { useOrthBoundStore } from '../../../orthodontics/stores/useStore';
import { useBoundStore } from '../../../surgeries/stores/useStore';
import { SaveChangesHook } from '../../shared';
import { useSaveProgress } from '../useSaveProgress';

export function useSaveIPR(): SaveChangesHook {
  const setWebBusy = useBoundStore((state) => state.setWebBusy);
  const setLowerDentalMovements = useOrthBoundStore((state) => state.setLowerDentalMovements);
  const setUpperDentalMovements = useOrthBoundStore((state) => state.setUpperDentalMovements);
  const { saveProgressInBackend } = useSaveProgress();

  const saveChanges = useCallback(async (): Promise<boolean> => {
    setWebBusy(true);

    const { upperMovements, lowerMovements } = window.App.webEventsProxy.movements.getTreatmentMovements();
    setLowerDentalMovements(lowerMovements);
    setUpperDentalMovements(upperMovements);

    await saveProgressInBackend({ lower: lowerMovements, upper: upperMovements }, OrthodonticsPhasesKeys.IPR);

    setWebBusy(false);
    return Promise.resolve(true);
  }, [setLowerDentalMovements, setUpperDentalMovements, saveProgressInBackend]);

  return { saveChanges };
}
